import React, { PureComponent } from 'react';
import {
    Row,
    Button,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Collapse,
    ButtonDropdown,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { Colxx } from '../../../components/common/CustomBootstrap';
import Breadcrumb from '../../navs/Breadcrumb';
import IntlMessages from '../../../helpers/IntlMessages';
import classnames from 'classnames';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import ThumbListIcon from '../../../components/ThumbListIcon';
import DataListIcon from '../../../components/DataListIcon';
import TableImport from './TableImport';
import ComponentToPrintTem from '../ComponentToPrintTem';
import ReactToPrint from 'react-to-print';

const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

class PageHeading extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            dropdownSplitOpen: false,
            isOpenModal: false,
            dataImport: [],
        };
        this.componentRef = React.createRef();
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                this.setState({ dataImport: jsonData });
            };
            reader.readAsArrayBuffer(file);
        }
    };

    handleDownloadData = () => {
        const fileName = 'Danh sách Sản phẩm';

        this.exportToCSV({
            csvData: this.formatDatasExport(this.props.data),
            fileName,
        });
    };

    toggleSplit = () => {
        this.setState((prevState) => ({
            dropdownSplitOpen: !prevState.dropdownSplitOpen,
        }));
    };

    toggleDisplayOptions = () => {
        this.setState((prevState) => ({
            displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
        }));
    };

    formatDatasExport = (data) => {
        // console.log('data: ', data)
        let custs = [];

        for (let i = 0, j = data?.length; i < j; i++) {
            custs.push({
                Stt: i + 1,
                'Id sản phẩm': data[i].id,
                'Tên sản phẩm': data[i].name,
                'Mã SKU': data[i].sku,
                'Barcode': data[i].barcode,
                'Danh mục sản phẩm': data[i].category.name,
                'Image': data[i].image,
                'Khuyên dùng': data[i].bestter ? 'Có' : 'Không',
                'Giá bán': data[i].price,
                'Giá khuyến mãi': data[i].price_sale,
                Topping: data[i].topping
                    ?.map((obj) => `${obj.name}|${obj.value}`)
                    .join(', '),
                'Kích thước': data[i].size
                    ?.map((obj) => `${obj.name}|${obj.value}`)
                    .join(', '),
                'Lượng đá': data[i].ice?.map((i) => i).join(', '),
                'Độ ngọt': data[i].sugar.map((s) => s).join(', '),
                'Ẩn/Hiện': data[i].softHide ? 'Đang ẩn' : 'Đang hiện',
                'Ngày tạo': data[i].date,
                'Ngày cập nhật': data[i].updatedAt,
            });
        }
        return custs;
    };

    exportToCSV = ({ csvData, fileName }) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    toggleOpenModal = () => {
        this.setState({
            ...this.state,
            isOpenModal: !this.state.isOpenModal,
            dataImport: []
        });
    };

    render() {
        const { messages } = this.props.intl;
        const {
            heading,
            hide_button_add,
            setting,
            match,
            data_all,
            totalItem,
            toggleFunc,
            // isDisabledAdd,
            changePageSizeFunc,
            handleInputChange,
            handleKeyDown,
            displayMode,
            changeDisplayMode,
            handleImportProduct,
        } = this.props;

        // console.log('render PageHeadingComponent');
        // console.log('render PageHeading');

        const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
        const endIndex = setting.currentPage * setting.selectedPageSize;

        const { displayOptionsIsOpen, dataImport } = this.state;
        // console.log('dataImport: ', dataImport)
        return (
            <Row className='list-page-heading__row'>
                <Colxx xxs='12'>
                    <div className='d-fex justify-content-between align-items-center mb-2'>
                        <h1>
                            <IntlMessages id={heading} />
                        </h1>
                        <div className='text-zero top-right-button-container'>
                            {/* <Button
                                color='primary'
                                size='md'
                                className={classnames('top-right-button', {
                                    disable: isDisabledAdd,
                                })}
                                onClick={() => toggleFunc()}
                            >
                                <IntlMessages id='pages.add-new' />
                            </Button>
                            {'  '}
                             */}
                            <ButtonDropdown
                                isOpen={this.state.dropdownSplitOpen}
                                toggle={this.toggleSplit}
                            >
                                <Button
                                    color='primary'
                                    size='md'
                                    className={classnames('top-right-button position-relative', {
                                        disable: hide_button_add,
                                    })}
                                    onClick={
                                        hide_button_add
                                            ? null
                                            : () => toggleFunc()
                                    }
                                >
                                    <IntlMessages id='pages.add-new' />
                                    {hide_button_add ? (<i className='simple-icon-diamond diamond-upgrade-add' />) : null}
                                </Button>
                                <DropdownToggle caret color='primary' />
                                <DropdownMenu>

                                    {this.componentRef && (
                                        <ReactToPrint
                                            trigger={() => (
                                                <DropdownItem className='d-flex align-items-center'
                                                    // onClick={this.toggleOpenModal}
                                                >
                                                    <i className='simple-icon-printer pr-2' />
                                                    In tem tất cả
                                                </DropdownItem>
                                            )}
                                            content={() =>
                                                this.componentRef
                                            }
                                        />
                                    )}
                                    <DropdownItem divider />
                                    <DropdownItem
                                        className='d-flex align-items-center'
                                        onClick={this.toggleOpenModal}
                                    >
                                        <i className='simple-icon-cloud-upload pr-2' />
                                        Tải lên từ file excel
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                        onClick={this.handleDownloadData}
                                        className='d-flex align-items-center'
                                    >
                                        <i className='simple-icon-cloud-download pr-2' />
                                        Tải về file excel
                                    </DropdownItem>
                                </DropdownMenu>
                            </ButtonDropdown>
                        </div>
                        <Breadcrumb match={match} />
                    </div>

                    <div className='mb-2'>
                        <Button
                            color='empty'
                            className='pt-0 pl-0 d-inline-block d-md-none'
                            onClick={this.toggleDisplayOptions}
                        >
                            <IntlMessages id='pages.display-options' />{' '}
                            <i className='simple-icon-arrow-down align-middle' />
                        </Button>
                        <Collapse
                            isOpen={displayOptionsIsOpen}
                            className='d-md-block'
                            id='displayOptions'
                        >
                            <span className=' d-none d-md-flex mr-3 d-inline-block float-md-left '>
                                <a
                                    href='#/'
                                    className={`mr-2 view-icon ${
                                        displayMode === 'thumblist'
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        changeDisplayMode('thumblist')
                                    }
                                >
                                    <ThumbListIcon />
                                </a>
                                <a
                                    href='#/'
                                    className={`mr-2 view-icon ${
                                        displayMode === 'list' ? 'active' : ''
                                    }`}
                                    onClick={() => changeDisplayMode('list')}
                                >
                                    <DataListIcon />
                                </a>
                            </span>
                            <div className='d-block d-md-inline-block'>
                                <div className='search-sm d-inline-block float-md-left mr-1 mb-1 align-top'>
                                    <input
                                        type='text'
                                        name='keyword'
                                        id='search'
                                        placeholder={messages['product.search']}
                                        onChange={handleInputChange}
                                        onKeyDown={handleKeyDown} // Cho phép search ngay khi nhấn Enter
                                    />
                                </div>
                            </div>
                            {displayMode === 'list' ? null : (
                                <div className='float-md-right'>
                                    <span className='text-muted text-small mr-1'>{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                                    <UncontrolledDropdown className='d-inline-block'>
                                        <DropdownToggle
                                            caret
                                            color='outline-dark'
                                            size='xs'
                                        >
                                            {setting.selectedPageSize}
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {setting.pageSizes.map(
                                                (size, index) => {
                                                    return (
                                                        <DropdownItem
                                                            key={index}
                                                            onClick={() =>
                                                                changePageSizeFunc(
                                                                    size
                                                                )
                                                            }
                                                        >
                                                            {size}
                                                        </DropdownItem>
                                                    );
                                                }
                                            )}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            )}
                        </Collapse>
                    </div>
                    {/* <Separator /> */}
                </Colxx>
                <Modal
                    isOpen={this.state.isOpenModal}
                    toggle={this.toggleOpenModal}
                    className={classnames(
                        'table-modal cursor-pointer max-width-100'
                    )}
                >
                    <ModalHeader toggle={this.toggleOpenModal}>
                        Nhập dữ liệu từ file excel
                    </ModalHeader>
                    <ModalBody
                        className={
                            'd-flex justify-content-center align-items-center modal-body-import'
                        }
                    >
                        {/* <PerfectScrollbar
                            options={{
                                suppressScrollX: true,
                                wheelPropagation: false,
                            }}
                        > */}
                        {dataImport.length ? (
                            <TableImport data={dataImport} />
                        ) : (
                            <input
                                type='file'
                                accept='.xlsx, .xls'
                                onChange={this.handleFileUpload}
                            />
                        )}
                        {/* </PerfectScrollbar> */}
                    </ModalBody>
                    <ModalFooter className={'d-flex justify-content-center'}>
                        <Button
                            color='primary'
                            onClick={() => handleImportProduct(dataImport)}
                        >
                            Import
                        </Button>
                    </ModalFooter>
                </Modal>
                <div style={{ display: 'none' }}>
                    {data_all.length ? data_all.map((data, idx) => {
                        return (
                            <ComponentToPrintTem
                                key={idx}
                                item={data}
                                ref={(el) => (this.componentRef = el)}
                            />
                        )
                    }) : null}
                </div>
            </Row>
        );
    }
}

export default injectIntl(PageHeading);
